module.exports = __webpack_public_path__ + "static/media/oracle.e71d1ba8.png";